import AbstractOperatorApplicationListener
    from "~/operatorApplication/ts/service/comet/AbstractOperatorApplicationListener";
import {OperatorApplicationEventManager} from "~/operatorApplication/ts/OperatorApplicationEventManager";
import Delay from "~/ts/library/Delay";
import {ClientUserdataStore} from "~/operatorApplication/ts/store/ClientUserdataStore";
import {OperatorApplicationDialogsStore} from "~/operatorApplication/ts/store/OperatorApplicationDialogsStore";
import {
    OPERATOR_APPLICATION_DIALOGS_ROUTE_LIST_ID_MAIN
} from "~/operatorApplication/ts/router/OperatorApplicationRouteNames";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import OperatorApplicationPlatformFactory from "~/operatorApplication/ts/platform/OperatorApplicationPlatformFactory";
import {__} from "~/ts/library/Translate";
import showNotificationAboutClientMessage
    from "~/operatorApplication/ts/service/dialog/ShowNotificationAboutClientMessage";

export default class Typing extends AbstractOperatorApplicationListener {
    public getAction(): string {
        return "typing";
    }

    public async receive(payload: CometOperatorApplication.TypingCometMessageOpenApiModel) {
        if (OperatorAccountStore.data.value.accessRights.canViewTyping) {
            let eventName = Typing.getEventNameByUsername(payload.username);

            if ((typeof payload.text == "string" && !payload.text.length) || ClientUserdataStore.isFreeByUsername(payload.username)) {
                payload.text = null;
            }
            OperatorApplicationEventManager.emit(eventName, payload.text);
            if (OperatorApplicationPlatformFactory.isNative) {
                let selectedUsername = OperatorApplicationDialogsStore.getSelectedUsername(OPERATOR_APPLICATION_DIALOGS_ROUTE_LIST_ID_MAIN);
                if (selectedUsername != payload.username) {
                    if (payload.showNotificationForOperatorLogin == OperatorAccountStore.operator.value.login) {
                        let client = await ClientUserdataStore.getByUsernameAsync(payload.username);
                        if (client) {
                            showNotificationAboutClientMessage(client, `${__("Печатает сообщение")}: ${payload.text}`, true);
                        }
                    }
                }
            }
            try {
                await Delay.make(10000, eventName, true);
                Typing.clear(payload.username);
            } catch (e) {

            }
        }
    }

    public static getEventNameByUsername(username: string): string {
        return `ClientTyping_${username}`;
    }

    public static clear(username: string) {
        OperatorApplicationEventManager.emit(
            Typing.getEventNameByUsername(username)
        );
    }

}